const VIEWER_ID_STORAGE_KEY = "rvd_viewer_id"

/**
 * 조회수 중복 판정용 브라우저 영속 식별자.
 * 백엔드가 (uniqueId × 치료사례) 유니크 인덱스로 재조회·새로고침을 걸러주므로,
 * 이 값은 반드시 영속이어야 한다 — 휘발 id를 보내면 새로고침마다 새 조회로 잡혀
 * 중복 방지 자체가 무너진다. 그래서 저장이 불가능한 환경(스토리지 차단 등)에서는
 * null을 돌려 등록을 아예 건너뛴다(과소집계가 과대집계보다 낫다).
 */
export const getViewerUniqueId = (): string | null => {
  try {
    const existing = window.localStorage.getItem(VIEWER_ID_STORAGE_KEY)
    if (existing) return existing
    const created = window.crypto.randomUUID()
    window.localStorage.setItem(VIEWER_ID_STORAGE_KEY, created)
    return created
  } catch {
    return null
  }
}
